import { Component, forwardRef, Input, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-password-custom-field',
  templateUrl: './password-custom-field.component.html',
  styleUrls: ['./password-custom-field.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordCustomFieldComponent),
      multi: true
    }
  ]
})
export class PasswordCustomFieldComponent implements ControlValueAccessor, AfterViewInit, OnDestroy {
  @Input() label: string = 'UserPages.UserChangePassword.Password';
  @Input() placeholder: string = '';
  @Input() minlength: number = 8;
  @Input() showRequirements: boolean = true;
  @Input() appendTo: 'body' | null = null;

  @ViewChild('inputField') inputField?: ElementRef;
  @ViewChild('overlayPanel') overlayPanel?: ElementRef;

  showPassword = false;
  overlayVisible = false;
  showOverlayAbove = false;
  value: string = '';
  disabled: boolean = false;
  @Input()
  class: string = '';

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  ngAfterViewInit(): void {
    // Initialization if needed
  }

  ngOnDestroy(): void {
    if (this.overlayPanel && this.overlayPanel.nativeElement.parentNode === document.body) {
      document.body.removeChild(this.overlayPanel.nativeElement);
    }
  }

  // Password strength requirements
  get hasMinLength(): boolean {
    return this.value.length >= this.minlength;
  }

  get hasUpperCase(): boolean {
    return /[A-Z]/.test(this.value);
  }

  get hasLowerCase(): boolean {
    return /[a-z]/.test(this.value);
  }

  get hasNumber(): boolean {
    return /[0-9]/.test(this.value);
  }

  get hasSpecialChar(): boolean {
    return /[!@#$%^&*(),.?":{}|<>]/.test(this.value);
  }

  get passwordStrength(): number {
    const requirements = [
      this.hasMinLength,
      this.hasUpperCase,
      this.hasLowerCase,
      this.hasNumber
    ];
    const fulfilled = requirements.filter(req => req).length;
    return (fulfilled / requirements.length) * 100;
  }

  get strengthClass(): string {
    if (this.passwordStrength >= 100) return 'strength-strong';
    if (this.passwordStrength >= 75) return 'strength-good';
    if (this.passwordStrength >= 50) return 'strength-medium';
    if (this.passwordStrength >= 25) return 'strength-weak';
    return 'strength-very-weak';
  }

  // ControlValueAccessor methods
  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Component methods
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  onPasswordFocus(): void {
    if (this.showRequirements) {
      this.overlayVisible = true;
      setTimeout(() => this.calculateOverlayPosition(), 0);
    }
  }

  onPasswordBlur(): void {
    this.onTouched();
    setTimeout(() => {
      this.overlayVisible = false;
    }, 200);
  }

  private calculateOverlayPosition(): void {
    this.toggle() // Mover el panel al body para calcular su posición correctamente
    // if (!this.inputField || !this.overlayPanel) return;

    // const inputElement = this.inputField.nativeElement;
    // const overlayElement = this.overlayPanel.nativeElement;
    // const inputRect = inputElement.getBoundingClientRect();
    // const overlayHeight = overlayElement.offsetHeight || 300; // Altura estimada si aún no está renderizado
    // const viewportHeight = window.innerHeight;
    // const spaceBelow = viewportHeight - inputRect.bottom;
    // const spaceAbove = inputRect.top;

    // // Si no hay suficiente espacio abajo pero sí arriba, mostrar arriba
    // this.showOverlayAbove = spaceBelow < overlayHeight && spaceAbove > overlayHeight;
  }

  toggle() {
    if(this.overlayPanel && this.inputField)
    {
        document.body.appendChild(this.overlayPanel.nativeElement);

        const rect = this.inputField.nativeElement.getBoundingClientRect();

        const panel = this.overlayPanel.nativeElement;

        panel.style.position = 'fixed';
        panel.style.top = `${rect.bottom + 4}px`;
        panel.style.left = `${rect.left}px`;
        panel.style.zIndex = '9999';

        // ancho igual al input
        panel.style.width = `${rect.width}px`;
    }

  }
}
